<template>
  <div>
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">订单管理</div>
      <div class="nav-right">
        <img class="none" />
      </div>
    </div>

    <div class="ub ub-pc ub-ac1 order-sort">
      <div @click="chosesex('', 0)" :class="chosed == 0 ? 'order-on' : ''">
        全部
      </div>
      <div
        @click="chosesex('待服务', 1)"
        :class="chosed == 1 ? 'order-on' : ''"
      >
        待服务
      </div>
      <div
        @click="chosesex('服务中', 2)"
        :class="chosed == 2 ? 'order-on' : ''"
      >
        服务中
      </div>
      <div
        @click="chosesex('已完成', 3)"
        :class="chosed == 3 ? 'order-on' : ''"
      >
        已完成
      </div>
    </div>

    <div class="ub ub-ver order-block">
      <div
        class="ub ub-ac2 order-item"
        v-for="(item, index) in ary_order"
        :key="index"
      >
        <div class="photo-block ub ub-ver ub-pc">
          <div class="infoma ub">
            <div class="photo-black">
              <img :src="item.photo" class="photo" />
            </div>
          </div>
          <span class="nick2">{{ item.nick }}</span>
        </div>

        <div class="ub ub-ac2 ub-ver service">
          <div>
            <span class="sp1">服务类型:&nbsp;</span>
            <span class="sp2">{{ item.play_type }}</span>
          </div>
          <div class="time">
            <span class="sp1">服务时长:&nbsp;</span>
            <span class="sp2">{{ item.play_time_ch }}</span>
          </div>
          <div class="">
            <span class="sp1">订单状态:&nbsp;</span>
            <span class="sp2">{{ item.order_state }}</span>
          </div>
        </div>

        <div class="ub ub-ver ub-pc ub-ac2">
          <div class="infoma2 ub ub-ver ub-pc">
            <img :src="item.photo2" class="photo2" />
            <span class="nick3">{{ item.nick2 }}</span>
          </div>

          <div class="ub ub-ac2 ub-pc">
            <div class="ub ub-pc" style="margin-right: 0.5em">
              <span class="btn">再来一单</span>
            </div>

            <div class="ub ub-pc" @click="goto_play_appraise(item.id)">
              <span class="btn">评价</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      ary_order: [],
      order: "",
      chosed: "",
      index: 0,
      size: 20,
    };
  },
  mounted() {
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    chosesex(order, chosed) {
      this.order = order;
      this.chosed = chosed;
    },
    goto_play_appraise(id) {
      this.$router.push({ name: "play_appraise", params: { "play_order_id": id } });
    },
    init_page() {
      this.$loading("加载中...");
      var uid = this.$store.state.uid;
      var self = this;
      self.get({
        url:
          "/App/Get_Order_List_Data/?uid=" +
          uid +
          "&index=" +
          this.index +
          "&size=" +
          this.size,
        success: function (data_serve) {
          //console.log(JSON.stringify(data_serve));
          self.$loading.close();

          if (data_serve.length <= 0 && self.index > 0) {
            self.$toast.center("没有更多了~");
            return false;
          }
          for (var i = 0; i < data_serve.length; i++) {
            data_serve[i].photo =
              self.$store.state.url + "/photo/" + data_serve[i].photo;
          }
          self.ary_order = self.ary_order.concat(data_serve);
          self.index++;
        },
        error: function (err) {},
      });
    },
  },
};
</script>

<style scoped>
.order-sort {
  padding: 0.8em;
  color: #333;
  background-color: #fff;
}
.order-sort div {
  padding-bottom: 0.1em;
  font-size: 0.95em;
}
.order-on {
  border-bottom: 2px solid #e92162;
  padding-bottom: 0.1em;
  color: #e92162;
  font-size: 0.96em;
}
.order-block {
  padding: 0.7em;
}
.order-item {
  background-color: #fff;
  border-radius: 0.5em;
  padding: 0.5em;
  margin-bottom: 0.7em;
}

.photo-block {
  padding-right: 0.8em;
}

.photo {
  width: 4em;
  height: 4em;
  border-radius: 50%;
  margin-right: 0.5em;
}
.photo2 {
  width: 2em;
  height: 2em;
  border-radius: 50%;
}
.nick2 {
  font-size: 0.9em;
  color: #333;
}
.nick3 {
  font-size: 0.6em;
}
.service {
  margin-top: 0.3em;
  font-size: 0.9em;
}
.service .sp1 {
  color: rgb(175, 174, 174);
}
.service .sp2 {
  color: #333;
}
.time {
  margin: 0.5em 0;
}
.btn {
  border: 1px solid #e92162;
  border-radius: 1em;
  padding: 0.2em 0.5em;
  font-size: 0.7em;
  color: #e92162;
}
</style>